// nature
export const emojiList1a = [
  "🌱",
  "🍀",
  "🌹",
  "🦴",
  "🌈",
  "⚡",
  "❄️",
  "💧",
  "🔥",
  "💡",
];
export const emojiList1b = [
  "🦢",
  "🐁",
  "🐇",
  "🐿️",
  "🐒",
  "🦥",
  "🦋",
  "🐝",
  "🐎",
  "🦁",
];
// activities
export const emojiList2a = [
  "🐈",
  "🐕",
  "🐉",
  "🦖",
  "🐢",
  "🐍",
  "🦅",
  "🦆",
  "🐓",
  "🦉",
];
export const emojiList2b = [
  "🐳",
  "🐬",
  "🐠",
  "🦑",
  "🏝️",
  "⛰️",
  "🗺️",
  "⛺",
  "🛏️",
  "🧸",
];
// food
export const emojiList3a = [
  "🎨",
  "🎼",
  "🎤",
  "⚗️",
  "🩸",
  "🍼",
  "🛣️",
  "🚂",
  "⚓",
  "🌃",
];
export const emojiList3b = [
  "🎭",
  "🛠️",
  "🥘",
  "🎞️",
  "🛍️",
  "🎮",
  "📱",
  "💻",
  "📚",
  "🖊️",
];
// objects
export const emojiList4a = [
  "💪",
  "🏃",
  "🏟️",
  "🎲",
  "♟️",
  "📆",
  "💼",
  "📸",
  "🧵",
  "🎯",
];
export const emojiList4b = [
  "🏴‍☠️",
  "🧟",
  "🧙",
  "🦹",
  "👑",
  "🛸",
  "🌌",
  "🤹",
  "🪁",
  "⚖️",
];
